import { render, staticRenderFns } from "./ExpensesStartupCosts.vue?vue&type=template&id=605dd9b8"
import script from "./ExpensesStartupCosts.vue?vue&type=script&lang=js"
export * from "./ExpensesStartupCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports